module.exports = __webpack_public_path__ + "img/identificationOk.e4709fd3.svg";